import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import Form from './Form'
import ActionGet from '../../store/action/Holiday/Fetch'
import ActionDelete from '../../store/action/Holiday/Delete'
import ActionGetAllClient from '../../store/action/Client/FetchAll'
import CustomGrid from '../../infra/components/grid/custom-grid-without-search'
import "../../source/util.css"
import { IsEdit, IsCreate, IsView, InputTypeCombobox } from '../../store/constants'
import {ClientId, PrevilageId} from '../../helper/HelperAuth'
import BusinessHour from './BusinessHour'
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import TextInputField from "../../infra/components/formInput/CustomTextInput";
import DatePickerInput from "../../infra/components/formInput/DatePickerInput";
import ActionFindByGroupId from '../../store/action/Previlage/FindByGroupId'
import Swal from "sweetalert2";

class Page extends Component {
    constructor(props) {
        super(props)
        this.state = {
            title: "Business Hour",
            form: fromJS({
                show: false,
                actionType: '',
                item: fromJS({}),
                isadmin:false
            }),
            formSearch: fromJS({
                "search": "",
                "client-id":""
            }),
            searchForm : fromJS({
                "client-id": '',
                "date": '',
                "auto-reply" : ''
            }),
            search: fromJS([
                { widthClass: 'col-sm-6', id: 'search', placeholder: 'Search', label: '', value: '' },
                { widthClass: 'col-sm-6', id: 'client-id', placeholder: 'Client Id', label: '', value: '', inputType: InputTypeCombobox, data: fromJS([]) },
            ]),
            columns: [
                { className: "col-sm-1", cfield: "counter", caption: "No" },
                { className : "col-sm-2", field: "client-name", caption: "client", allowSearch: true },
                { className: "col-sm-2", field: "date", caption: "Date", allowSearch: true },
                { className: "", field: "auto-reply", caption: "auto reply", allowSearch: true },
                { className: "col-sm-1", cfield: "action", caption: "Actions", allowView: false }
            ],
            errors: fromJS({})
        };

        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleFind = this.handleFind.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this);
        this.handleEditClicked = this.handleEditClicked.bind(this);
        this.handleRemoveClicked = this.handleRemoveClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
    }

    async componentDidMount() {
        var isAdmin = await this.props.actionFindByGroupId();
        this.setState({isadmin:isAdmin})
        this.props.actionGetAllClient()
    }

    handleSearch(obj) {
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleCancelForm(refresh) {
        if (refresh) {
            // this.props.actionGet();
            this.handleFind();
        }
        this.setState({
            form: fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew() {
        this.setState({
            form: fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handleViewClicked = (value) => {
        this.setState({
            form: fromJS({
                show: true,
                actionType: IsView,
                item: value
            })
        })
    }

    handleEditClicked = (value) => {
        this.setState({
            form: fromJS({
                show: true,
                actionType: IsEdit,
                item: value
            })
        })
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    refreshGrid(page, search) {
        this.props.actionGet(page, search);
    }

    async handleRemoveClicked(value) {
        var body = {
            "data": {
                "holidays-id": value.get('holiday-id')
            }
        };
        var temp = await this.props.actionDelete(body);
        if (temp.ok) {
            Swal.fire("Deleted!", "Data has been deleted.", "success");
            toast.success('Delete ' + value.get('date') + ' Success!', toast.POSITION.TOP_RIGHT);
            // this.props.actionGet();
            this.handleFind();
        } else {
            Swal.fire("Failed!", "Failed to delete data.", "error");
            toast.error('Delete ' + value.get('date') + ' Failed!', toast.POSITION.TOP_RIGHT);
        }
    }

    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        formVal = formVal.set(field,value);
        this.setState({ searchForm:formVal })
    }
    
    handleFIndSearch(page) {
        const {searchForm} = this.state;
        let client_id = searchForm.get('client-id');
        var isAdmin = this.state.isadmin

        if (PrevilageId != 1 && isAdmin == false) client_id = ClientId;
        if ((PrevilageId == 1 || isAdmin == true) && client_id == "") client_id = 0;
        var bodyFInd = {
            "client-id" : client_id,
            "date": searchForm.get('date'),
            "auto-reply" : searchForm.get('auto-reply')
        }
        this.props.actionGet(page,this.state.sortForm, bodyFInd);
    }

    handleFind() {
        this.handleFIndSearch(1);
    }

    showContent() {
        var form = this.state.form;

        if (form.get('show')) {
            return (
                <Form
                    actionType={form.get('actionType')}
                    item={form.get('item')}
                    handleCancelForm={this.handleCancelForm}
                    handleSubmitOnForm={this.handleSubmitOnForm}
                >
                </Form>
            )
        } else {
            const items = this.props.data ? fromJS(this.props.data) : fromJS({});
            const { searchForm, errors } = this.state;
            const title = form.get('show') ? (form.get('actionType') === IsCreate ? "Add Holiday" : "Edit Holiday") : "Business Hour";
            const classHide = title == 'Business Hour' ? 'card' : 'card hidden'
            return (
                <div className="clearfix">
                    <BusinessHour></BusinessHour>
                    <div className="card-noborder-mid">
                        <h4>
                            Holiday
                        </h4>
                    </div>
                    <div className=  {classHide}>
                        <div className="body">
                            <div className="row">
                                <div className="col-sm-3">
                                    <ComboboxInput
                                        field='client-id'
                                        value={searchForm.get('client-id')}
                                        options={fromJS({
                                            'source': this.props.clientall,
                                            'value': 'client-id',
                                            'label': 'client-name'
                                        }) }
                                        onChange={(field, value, label) => this.handleChange(field,value,label)}
                                        placeholder="Client"
                                    />
                                </div>
                                <div className='col-sm-3'>
                                    <TextInputField className="form-control"
                                        field='auto-reply'
                                        value={searchForm.get('auto-reply')}
                                        onChange={(field, value) => this.handleChange(field,value, '')}
                                        placeholder="Auto Reply"
                                        disabled={ false }
                                        hasError={errors.has('auto-reply')}
                                    />
                                </div>
                                <span className="col-sm-1">Date</span>
                                <div className="col-sm-4">
                                    <DatePickerInput
                                        convertvalue
                                        dateFormat="dd-MM-yyyy"
                                        field="date"
                                        value={ searchForm.get('date') }
                                        onChange={(field, date) => this.handleChange(field, date)}
                                    />
                                </div>
                            </div>
                            <div className="row no-margin-bottom" >
                                <div className="col-sm-2">
                                    <button type="button"
                                            className="btn btn-wide btn-success"
                                            onClick={this.handleFind}>
                                        Search
                                    </button>
                                </div>
                                <div className="col-sm-1"></div>
                                <div className="col-sm-2">
                                    <button type="button"
                                            className="btn btn-wide btn-success content-add"
                                            onClick={this.handleNew}>
                                        <i className="material-icons">{'add'}</i>{'Add'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CustomGrid
                        title="Business Hour"
                        columns={this.state.columns}
                        items={items}
                        search={this.state.search}
                        handleSearch={this.handleSearch}
                        handleViewClicked={this.handleViewClicked}
                        handleEditClicked={this.handleEditClicked}
                        handleRemoveClicked={this.handleRemoveClicked}
                        handlePageChanged={this.handlePageChanged}
                    >
                    </CustomGrid>
                </div>
            )
        }
    }

    render() {
        const { form } = this.state;
        const title = form.get('show') ? (form.get('actionType') === IsCreate ? "Add Holiday" : "Edit Holiday") : "Business Hour";
        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        {title}
                    </h4>
                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
    (state) => {
        return {
            data: state.user.holidays,
            clientall: state.user.clientall,
        }
    },
    dispatch => bindActionCreators({
        actionFindByGroupId:ActionFindByGroupId,
        actionGet: ActionGet,
        actionGetAllClient:ActionGetAllClient,
        actionDelete: ActionDelete,
    }, dispatch),
)(Page);